export default "__VITE_ASSET__46d38746__"